/**
 * @generated SignedSource<<a3ee15b97889451dab7b0d5ee5b902ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FieldDetailsReportsFragment$data = {
  readonly reports: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly area: any | null;
        readonly date: any;
        readonly field: {
          readonly year: number;
        } | null;
        readonly id: string;
        readonly type: {
          readonly description: string;
          readonly externalCode: string;
        };
        readonly units: number | null;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "FieldDetailsReportsFragment";
};
export type FieldDetailsReportsFragment$key = {
  readonly " $data"?: FieldDetailsReportsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsReportsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldDetailsReportsFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "-created"
          ]
        }
      ],
      "concreteType": "ReportNodeConnection",
      "kind": "LinkedField",
      "name": "reports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReportNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReportTypeNode",
                  "kind": "LinkedField",
                  "name": "type",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "units",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "area",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FieldNode",
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "year",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reports(orderBy:[\"-created\"])"
    }
  ],
  "type": "FieldNode",
  "abstractKey": null
};

(node as any).hash = "ebe5e803214b8470380b00a56b732ab5";

export default node;
